// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3u-W7","large":"styles_large__3Ed5t"};